import Link from 'next/link';
import { useEffect } from 'react';
import { getIntercomAppId } from 'utils/intercom';
import WhiteLabelContent from 'components/app-components/sign-in/WhiteLabelContent';
import { getWhiteLabelWelcomePageTitle, getWhiteLabelLogoUrl } from 'utils/whiteLabelConfig';

const WhiteLabelLogo = ({ className = 'h-8 w-auto' }) => {
  const logoUrl = getWhiteLabelLogoUrl();
  return <img className={className} src={logoUrl} alt="Company Logo" />;
};

export const AuthContainer = ({ children, verticallyCentered = true }) => {
  return (
    <div className="auth-layout-container relative min-h-full bg-white">
      {/* Absolute (not fixed) → positioned against the page, not the viewport, so it scrolls away
          with the rest of the content instead of staying pinned on top of it once the form scrolls
          under where it sits. */}
      <div className="visible absolute left-0 top-0 mb-12 mt-12 w-full lg:hidden">
        <WhiteLabelLogo className="mx-auto mb-6 h-9" />
      </div>
      <div className={`flex min-h-screen flex-col items-center ${verticallyCentered ? 'justify-center' : ''}`}>
        {children}
      </div>
    </div>
  );
};

const WhiteLabelPageLogoTitle = () => {
  const pageTitle = getWhiteLabelWelcomePageTitle();

  return (
    <>
      <Link href="/">
        <WhiteLabelLogo className="mx-auto mb-6 h-9" />
      </Link>
      <h1 className="text-center text-xl font-semibold text-neutral-800" data-testid="pageTitle">
        {pageTitle}
      </h1>
    </>
  );
};

const WhiteLabelLoginLayout = ({ children, showRightContainer = true, isVerifyEmailPage = false }) => {
  useEffect(() => {
    if (!(window as any).Intercom) return;
    const openIntercom = () => {
      (window as any).Intercom('boot', {
        api_base: 'https://api-iam.intercom.io',
        app_id: getIntercomAppId(),
      });
    };
    openIntercom();
  }, []);

  return (
    <AuthContainer>
      <div className={`mx-auto max-w-md md:max-w-screen-lg`}>
        <div
          className={`w-full rounded-xl bg-white lg:border lg:border-gray-200 ${isVerifyEmailPage ? 'p-4 md:p-12' : 'p-12'}`}
        >
          <div
            className={`${showRightContainer ? 'gap-24 lg:grid lg:max-w-none lg:grid-cols-2 lg:items-center' : 'min-w-sm max-w-sm'} max-w-md`}
          >
            <div>
              {!showRightContainer && (
                <div className={`mb-12 flex flex-col items-center justify-center`}>
                  <WhiteLabelPageLogoTitle />
                </div>
              )}
              {children}
            </div>
            {showRightContainer && <WhiteLabelContent />}
          </div>
        </div>
      </div>
    </AuthContainer>
  );
};

export default WhiteLabelLoginLayout;
